const reportMenus = [
  {
    icon: "edit",
    key: "configuration.billing-cdr",
    name: "Billing CDR",
    url: "home/app/billing/Cdr",
    description: "",
    productionReady: true,
  },
  {
    icon: "phone_callback",
    key: "rawCdrReport",
    name: "Raw CDR Report",
    url: "home/app/rawCdrReport",
    description: "Search raw CDRs by number and time; trace related call legs",
    productionReady: true,
    disabled: false,
  },
  {
    icon: "terminal",
    key: "cliCommandLog",
    name: "CLI Command Log",
    url: "home/app/cliCommandLog",
    description: "Audit log of CLI commands pushed to the call server",
    productionReady: true,
    disabled: false,
  },
  {
    icon: "summarize",
    key: "billingcdrsummary",
    name: "Extension Performance Summary",
    url: "home/app/extensionPerformanceSummary",
    description:"",
    productionReady: true,
    disabled: false,
  },
  {
    icon: "details",
    key: "billingcdrdetails",
    name: "Extension CDR Details",
    url: "home/app/billingcdrdetails",
    description: "",
    productionReady: true,
    disabled: false,
  },
  {
    icon: "details",
    key: "Feature.Extension.CDR.Details",
    name: "Feature Extension CDR Details",
    url: "home/app/FeatureExtensionCDRDetails",
    description: "",
    productionReady: true,
    disabled: false,
  },
  {
    icon: "extension",
    key: "extension-billing-reports",
    name: "Extension-Billing-Reports",
    url: "home/app/extension-billing-reports",
    description: "",
    productionReady: true,
    disabled: false,
  },
  {
    icon: "request_quote",
    key: "billingsummary",
    name: "Call Billing Summary",
    url: "home/app/callbillingsummary",
    description: "",
    productionReady: true,
    disabled: false,
  },
  {
    icon: "summarize_icon",
    key: "csm_reports",
    name: "CMS Reports",
    url: "home/app/cms-reports",
    description: "",
    productionReady: true,
  },
  {
    icon: "article",
    key: "callDisposition.Analysis.Campaign",
    name: "Disposition Analysis-Campaign",
    url: "home/app/callDisposition",
    description: "",
    productionReady: true,
    disabled: true,
  },
  {
    icon: "analytics_icon  ",
    key: "campaign.Summary",
    name: "Campaign Summary",
    url: "home/app/campaignSummary",
    description: "",
    productionReady: true,
    disabled: true,
  },
  {
    icon: "crisis_alert",
    key: "configuration.nms-alert-history",
    name: "Nms-Alert-History",
    url: "home/app/configurations/nms-alert-history",
    description: "",
    productionReady: true,
  },
  {
    icon: "warning_icon",
    key: "configuration.eams",
    name: "EAMS",
    url: "home/app/configurations/EAMS",
    description: "",
    productionReady: true,
  },
  {
    icon: "calendar_view_week",
    key: "user.login.logout",
    name: "Agent-LogIn-LogOut",
    url: "home/app/configurations/user-login-logout",
    description: "",
    productionReady: true,
    disabled: false,
  },
  {
    icon: "summarize_icon",
    key: "Customer.CDRreport",
    name: "Customer CDR Rreport",
    url: "home/app/configurations/CustomerCDRreport",
    description: "",
    productionReady: true,
  },
  {
    icon: "folder_copy",
    key: "Operator.Summary",
    name: "Operator Summary",
    url: "home/app/configurations/Operator Summary",
    description: "",
    productionReady: true,
  },
  {
    icon: "receipt",
    key: "pareport",
    name: "PA Reports",
    url: "home/app/configurations/PAreport",
    description: "",
    productionReady: true,
  },
  {
    icon: "summarize",
    key: "agent.performance.Daily",
    name: "Agent Performance Report",
    url: "home/app/billing/agent-performance",
    description: "",
    productionReady: true,
    disabled: true,
  },
  {
    icon: "summarize",
    key: "agent.performance.summary",
    name: "Agent Performance Summary",
    url: "home/app/billing/agent-performance-summary",
    description: "",
    productionReady: true,
    disabled: true,
  },
  // {
  //   icon: "summarize",
  //   key: "agent-DailyReport",
  //   name: "Daily Report",
  //   url: "home/app/billing/agent-dailyReport",
  //   description: "Agent Daily Report",
  //   productionReady: true,
  //   disabled: false,
  // },
  {
    icon: "summarize",
    key: "aagent.performance.Daily",
    name: "Daily Report",
    url: "home/app/billing/agent-performance",
    productionReady: true,
  },
  {
    icon: "calendar_view_week",
    key: "group.abandoned.call",
    name: "Group Abandoned Call",
    url: "home/app/configurations/report/GroupAbandonedCall",
    description: "",
    productionReady: true,
    disabled: false,
  },
  {
    icon: "call_received_icon",
    key: "inboundReport",
    name: "Last 10 - Inbound Call",
    url: "home/app/configurations/report/inboundReport",
    description: "",
    productionReady: true,
    disabled: true,
  },
  {
    icon: "tty_icon",
    key: "outboundReport",
    name: "Last 10 - Outbound Call",
    url: "home/app/configurations/report/outboundReport",
    description: "",
    productionReady: true,
    disabled: true,
  },
  {
    icon: "call_missed_icon",
    key: "missedCallReport",
    name: "Last 10 - Missed Call",
    url: "home/app/configurations/report/missedCallReport",
    description: "",
    productionReady: true,
    disabled: true,
  },
  {
    icon: "summarize_icon",
    key: "agentcdrreport",
    name: "Agent CDR Report",
    url: "home/app/configurations/report/agentcdrreport",
    description: "",
    productionReady: true,
    disabled: true,
  },
  {
    icon: "summarize",
    key: "queue.Performance.Daily",
    name: "Queue-Performance",
    url: "home/app/configurations/report/queuePerformance",
    description: "",
    productionReady: true,
    disabled: true,
  },
  {
    icon: "article",
    key: "queue.Performance.Summary",
    name: "Queue-Performance-Summary",
    url: "home/app/configurations/report/queuePerformanceSummary",
    description: "",
    productionReady: true,
    disabled: true,
  },
  {
    icon: "folder_copy",
    key: "consolidatedExtension",
    name: "Extension Properties",
    url: "home/app/configurations/consolidatedExtension",
    description: "",
    productionReady: true,
  },
  {
    icon: "folder_copy",
    key: "internalForwardReport",
    name: "Internal Forward Report",
    url: "home/app/configurations/internalForward",
    description: "",
    productionReady: true,
    disabled: false,
  },
  {
    icon: "article",
    key: "agent.Call.DataAnalysis",
    name: "Agent Call Data Analysis",
    url: "home/app/AgentCallDataAnalysis",
    description: "",
    productionReady: true,
    disabled: true,
  },
  {
    icon: "article",
    key: "caller.Call.DataAnalysis",
    name: "Caller Call Data Analysis",
    url: "home/app/CallerCallDataAnalysis",
    description: "",
    productionReady: true,
    disabled: true,
  },
  {
    icon: "article",
    key: "last.Abandoned.Records",
    name: "Last Abandoned Records",
    url: "home/app/LastAbandonedRecords",
    description: "",
    productionReady: true,
    disabled: true,
  },
  {
    icon: "article",
    key: "answered",
    name: "Answered Report",
    url: "home/app/AnsweredReport",
    description: "",
    productionReady: true,
    disabled: true,
  },
  // {
  //   icon: "summarize",
  //   key: "queueAbandonedTransferCalls",
  //   name: "QueueAbandonedTransferCalls",
  //   url: "home/app/billing/QueueAbandonedTransferCalls",
  //   description: "Report",
  //   productionReady: true,
  // },
  {
    icon: "summarize",
    key: "dispositionAnalysisQueue",
    name: "DispositionAnalysisQueue",
    url: "home/app/billing/DispositionAnalysisQueue",
    description: "",
    productionReady: true,
    disabled: true,
  },
  {
    icon: "analytics_icon  ",
    key: "queueAbandonedReport",
    name: "Queue Abandoned",
    url: "home/app/QueueAbandonedReport",
    description: "",
    productionReady: true,
    disabled: false,
  },
  {
    icon: "calendar_view_week",
    key: "queueTimeInterval",
    name: "Queue Time Interval",
    url: "home/app/QueueTimeInterval",
    description: "",
    productionReady: true,
    disabled: true,
  },
  {
    icon: "summarize",
    key: "lead.Summary",
    name: "Lead Summary",
    url: "home/app/leadSummary",
    description: "",
    productionReady: true,
    disabled: true,
  },
  {
    icon: "summarize",
    key: "ViewleadSummary",
    name: "View Lead Summary",
    url: "home/app/viewleadSummary",
    description: "",
    productionReady: true,
    disabled: true,
  },
  // {
  //   icon: "folder_copy",
  //   key: "disposition.Analysis.Queue",
  //   name: "Queue Reports",
  //   url: "home/app/configurations/internalForward",
  //   description: "",
  //   productionReady: true,
  //   disabled: false,
  // },
];

export { reportMenus };
